import apiUsers from '../apis/User'

export async function selectRoles() {
  try {
    const response = await apiUsers.getRoles();
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}